// extracted by mini-css-extract-plugin
module.exports = {"pricingTable":"API_pricingTable__qQHca","featureList":"API_featureList__okc7d"};